
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Vasudeva Sutam Devam" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Stotra "Vasudeva Sutam Devam" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shri Krishnashtakam, Lord Krishna prayer, krishna stotra, vasudevasutam, Vasudeva Sutam Devam, Krishna Janmashtami, vasudeva sutam devam sloka lyrics'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Vasudeva Sutam Devam, Shri Krishnashtakam, Lord Krishna prayer, vasudevasutam, Devotional hymn, Devotional stotra, Ashtakshara mantra, Krishna bhakti, Krishna worship, Krishna Janmashtami, vasudeva sutam devam sloka lyrics, vasudeva sutam devam sloka lyrics english, vasudeva sutam devam sloka lyrics marathi' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/krishnashtakam.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/krishnashtakam.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Vasudeva Sutam Devam | Shri Krishnashtakam - वसुदेव सुतं देवं(श्री कृष्णाष्टकम्)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/krishnashtakam"
        },
        "headline": "Vasudeva Sutam Devam - वसुदेव सुतं देवं(श्री कृष्णाष्टकम्)",
        "name" : "Vasudeva Sutam Devam - Shri Krishnashtakam",
        "description": "Explore the full lyrics of stotra 'Vasudeva Sutam Devam' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/krishnashtakam.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  